
// import { actionTypes } from "./actions";
import { getformStateListAPI } from './endpoints';
import { actions } from 'store/Reducer/actions';

export const actionTypes = {
    FORMSTATE_GET_REQUEST: "FORMSTATE_GET_REQUEST",
    FORMSTATE_GET_RECEIVE: "FORMSTATE_GET_RECEIVE",
    FORMSTATE_GET_FAIL: "FORMSTATE_GET_FAIL"
  };

const requestFormState= () => ({
    type: actionTypes.FORMSTATE_GET_REQUEST,
});
const receiveFormState = (payload) => ({
    type: actionTypes.FORMSTATE_GET_RECEIVE,
    payload,
});
const failureFormState = (payload) => ({
    type: actionTypes.FORMSTATE_GET_FAIL,
    payload,
});
export const getFormStateAction = () => {
    return async (dispatch) => {
        dispatch(requestFormState());
        try {
            const response = await getformStateListAPI();
            if (response?.status === 200) {
                dispatch(receiveFormState(response?.data?.data));
               // dispatch(actions.successAlert("Coutries fetched successfully"));
            }
        } catch (error) {
            dispatch(failureFormState(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};
